import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Box,
  Button,
  MenuItem,
  Select,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import SwitchToggle from "../../components/SwitchToggle";
import dayjs from "dayjs";

const DiscountCoupon = () => {
  const navigate = useNavigate();

  const coupons = [
    {
      id: 1,
      name: "Diwali Offer",
      code: "DIWALI10",
      discount: "5%",
      minSales: "10 orders",
      applicableTime: "Evening (4 PM – 8 PM)",
      validFrom: "25 August 2025",
      validTo: "30 August 2025",
      store: "#ST001 - Downtown Store",
      createdDate: "30 July 2025",
      active: true,
    },
  ];

  const getStatus = (from: string, to: string) => {
    const today = dayjs();
    const start = dayjs(from, "DD MMMM YYYY");
    const end = dayjs(to, "DD MMMM YYYY");

    if (today.isBefore(start)) {
      return { label: "Scheduled", color: "#007BFF" }; // Blue
    }
    if (today.isAfter(end)) {
      return { label: "Expired", color: "#D32F2F" }; // Red
    }
    return { label: "Active", color: "#00B67A" }; // Green
  };

  return (
    <>
      <div className="main_title">
        <h1>Discount & Coupon Management</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          Discount & Coupon Management
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={""}
              setDebouncedSearchTerm={() => {}}
              placeholder="Search coupons..."
            />
          </div>

          <div className="right_s" style={{ display: "flex", gap: "12px" }}>
            {/* FILTER */}
            <div className="form">
              <div className="control_group ">
                <Select
                  defaultValue="all"
                  size="small"
                  sx={{
                    width: "150px",
                    background: "#fff",
                    borderRadius: "6px",
                  }}
                >
                  <MenuItem value="all">All</MenuItem>
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="expired">Expired</MenuItem>
                  <MenuItem value="scheduled">Scheduled</MenuItem>
                </Select>
              </div>
              <div style={{ marginLeft: "10px" }} className="control_group">
                {/* SORT */}
                <Select
                  defaultValue="newest"
                  size="small"
                  sx={{
                    width: "170px",
                    background: "#fff",
                    borderRadius: "6px",
                  }}
                >
                  <MenuItem value="newest">Newest First</MenuItem>
                  <MenuItem value="oldest">Oldest First</MenuItem>
                  <MenuItem value="a-z">A → Z</MenuItem>
                  <MenuItem value="z-a">Z → A</MenuItem>
                </Select>
              </div>
            </div>

            {/* ADD BUTTON */}
            <Button className="btn btn_primary" onClick={() => navigate("add")}>
              Add Discount and Coupon
            </Button>
          </div>
        </div>

        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sr. No</TableCell>
                <TableCell>Offer/Discount Name</TableCell>
                <TableCell>Coupon Code</TableCell>
                <TableCell>Discount</TableCell>
                <TableCell>Minimum Sales</TableCell>
                <TableCell>Applicable Time</TableCell>
                <TableCell>Valid From – To</TableCell>
                <TableCell>Store Detail</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {coupons.map((item, index) => {
                const status = getStatus(item.validFrom, item.validTo);

                return (
                  <TableRow hover key={item.id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{item.name}</TableCell>

                    <TableCell>
                      <Button
                        variant="outlined"
                        size="small"
                        sx={{
                          borderColor: "#00B67A",
                          color: "#00B67A",
                          fontWeight: 600,
                          borderRadius: "6px",
                          px: 1.5,
                          py: 0.2,
                        }}
                      >
                        {item.code}
                      </Button>
                    </TableCell>

                    <TableCell>{item.discount}</TableCell>
                    <TableCell>{item.minSales}</TableCell>
                    <TableCell>{item.applicableTime}</TableCell>

                    <TableCell>
                      {item.validFrom} – {item.validTo}
                    </TableCell>

                    <TableCell>
                      <a
                        href="/manage-stores/detail"
                        className="click_action"
                        onClick={() => navigate("/manage-stores/detail")}
                      >
                        <b>{item.store}</b>
                      </a>
                    </TableCell>

                    <TableCell>{item.createdDate}</TableCell>

                    {/* STATUS COLUMN */}
                    <TableCell>
                      <span
                        style={{
                          padding: "4px 10px",
                          borderRadius: "6px",
                          fontWeight: 600,
                          fontSize: "13px",
                          color: "#fff",
                          backgroundColor: status.color,
                        }}
                      >
                        {status.label}
                      </span>
                    </TableCell>

                    <TableCell>
                      <div className="table_actions v2">
                        <IconButton>
                          <img
                            onClick={() => navigate("view")}
                            src="/static/images/eye_icon.svg"
                            alt="View"
                          />
                        </IconButton>

                        <IconButton>
                          <img
                            onClick={() => navigate("add")}
                            src="/static/images/edit2_icon.svg"
                            alt="Edit"
                          />
                        </IconButton>

                        <IconButton>
                          <img
                            src="/static/images/trash2_icon.svg"
                            alt="Delete"
                          />
                        </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </>
  );
};

export default DiscountCoupon;
